import React from 'react'
// Shared by the standalone map and the lazy homepage preview.
// Shared geometry: the header and homepage use the same snow-bearing ledges.
export function BrandLogo({ idPrefix = 'brand' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="15 15 1030 520"
      className="brand-logo"
      role="img"
      aria-labelledby={`${idPrefix}-logo-title`}
    >
      <title id={`${idPrefix}-logo-title`}>
        杭州：屋檐、圆拱与舟形组合标志
      </title>
      <defs>
        <linearGradient
          id={`${idPrefix}-blue`}
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="15"
          x2="0"
          y2="535"
        >
          <stop offset="0" stopColor="#0753ff"></stop>
          <stop offset=".48" stopColor="#0085ff"></stop>
          <stop offset="1" stopColor="#00bced"></stop>
        </linearGradient>
      </defs>
      <g className="snow-back" aria-hidden="true"></g>
      <g className="logo-art" fill={`url(#${idPrefix}-blue)`}>
        <path d="M536 25C580 45 701 48 745 26C733 67 720 83 693 85H589C561 84 548 62 536 25Z"></path>
        <path d="M461 94C494 110 522 113 555 113H726C764 113 790 105 816 91C793 143 769 170 732 172H548C508 172 482 142 461 94Z"></path>
        <path d="M217 113C261 141 295 119 317 84C337 119 373 141 425 113C413 151 392 167 365 169H272C247 168 231 150 217 113Z"></path>
        <path d="M141 200C202 225 295 225 317 181C338 225 432 226 496 200C477 248 452 272 417 274H214C181 272 158 244 141 200Z"></path>
        <path d="M207 277H230V493Q230 514 209 515H121C81 510 56 464 31 407C88 454 135 445 207 445Z"></path>
        <path d="M308 278H330V505H308Z"></path>
        <path d="M406 277H430V444H578V423C542 404 518 364 518 318C518 249 571 194 639 194C707 194 760 249 760 318C760 364 739 401 702 423V445H796C884 445 952 404 1034 345C1005 403 967 445 921 476C881 502 834 516 774 516H678V407C715 392 738 358 738 318C738 261 694 216 639 216C584 216 541 261 541 318C541 358 565 394 601 407V514H433Q406 514 406 486Z"></path>
      </g>
      <g className="snow-beds" aria-hidden="true"></g>
      <g className="snow-caps" aria-hidden="true"></g>
      <g className="snow-front" aria-hidden="true"></g>
    </svg>
  )
}
